import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
  selector: 'app-ar-paid',
  templateUrl: './ar-paid.component.html',
  styleUrls: ['./ar-paid.component.scss']
})
export class ArPaidComponent implements OnInit {

  filters_form: FormGroup;
  isShow: boolean = false;
  searchText;
  stations;
  arPaidTrans = [];
  activeTab;
  constructor(private spinner: NgxSpinnerService,
    private arService: ArService,
    private router:Router,
    private modalService: BsModalService,
    ) {
      this.getPaidTransactions();
     }

  ngOnInit() {
    this.getPaidTransactions();
  }


  getPaidTransactions(payload = {}) {
    this.searchText = ''
    this.spinner.show();
    this.arService.getPaidTransactions(payload).subscribe(res => {
      this.spinner.hide();
      if(res['status'] && res['result'].length > 0 ){
        this.arPaidTrans = res['result'];

      } else {
        this.arPaidTrans = [];
      }
    });
    if(Object.keys(payload).length === 0) this.isShow = false;
  }
  showFilter() {
    this.isShow = !this.isShow;
  }
  exportExcel() {
    const exportData = this.arPaidTrans.map(trans => ({
      'Res ID': trans.RESID,
      'Res Type': trans.RES_TYPE,
      'Res Status': trans.RESSTATUS,
      'Billing Status': trans.GREET_SERVICE_BACKOFFICE_STATUS || '',
      'Currency': trans.CURRENCY_FLAG,
      'Station': trans.STATION,
      'Reservation Start Date': trans.STARTDT ? moment(trans.STARTDT).format('DD/MM/YYYY') : '',
      'Invoice ID': trans.INVOICE_RECEIPT_ID,
      'Sub Total': trans.TRANSACTION_SUBTOTAL,
      'Taxes': trans.TRANSACTION_TAXES,
      'Total': trans.TRANSACTION_TOTAL,
      'Transaction Type': trans.TRANSACTION_TYPE,
      'Chase Profile ID': trans.TRANSACTION_TYPE === 'Credit Card' ? trans.CCTRANSACTION_NUMBER : (trans.TRANSACTION_TYPE === 'Cheque' ? trans.CHEQUE_NUMBER : ''),
      'Customer Name': trans.CONTACT_NAME,
      'Customer Bill To (Company Name)': trans.COMPANY_NAME,
      'Payment Closed Date': trans.PAYMENT_CLOSED_DATE ? moment(trans.PAYMENT_CLOSED_DATE).format('DD/MM/YYYY') : '',
      'Notes': trans.NOTES,
      'Print Invoice': trans.PRINTED === 1 ? 'Yes' : 'No'
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    XLSX.writeFile(workbook, 'Paid_Transactions.xlsx');
  }
}
